var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import idHelper from "@irati/utils/id";
import { connect } from "@irati/store";
import { injectIntl } from "@irati/utils/lang";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import { walletTracking } from "@irati-tracking/wallet";
import notify from "@irati/utils/notify";
import WalletLink from "../../shared/WalletLink";
var UserWallet = /** @class */ (function (_super) {
    __extends(UserWallet, _super);
    function UserWallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserWallet.prototype.componentDidMount = function () {
        var _a = this.props, requested = _a.wallet.requested, getWallet = _a.getWallet, formatMessage = _a.formatMessage;
        if (!requested) {
            getWallet().catch(function () {
                notify.error({ message: formatMessage({ id: "platform.nav.wallet.get.error" }), position: "top-right" });
            });
        }
    };
    UserWallet.prototype.render = function () {
        var _a = this.props, id = _a.id, wallet = _a.wallet;
        var availableBalance = wallet.availableBalance, currency = wallet.currency;
        return (React.createElement(WalletLink, { id: idHelper("link-wallet", id), onClick: function () { return walletTracking.clickWalletBalance(availableBalance, currency); }, text: "platform.wallet.menu.user.title", to: "/", useIcon: false, wallet: wallet }));
    };
    return UserWallet;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserWallet));
